import React from "react";
// import "./dashboard/dashboard.css"
import "./middleupper.css";
import Package from "./package";
class MiddleUpper extends React.Component {
  constructor(props) {
    super(props);
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleSummaryClick = this.handleSummaryClick.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleFilterClick() {
    //console.log("clicking");
    this.props.onFilterClick();
  }

  handleSummaryClick() {}

  handleAddClick() {
    this.props.onAddClick(this.props.tag);
  }
  handleFilterChange(filters) {
    this.props.onFilterChange(filters);
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="top border-box clearfix leftalign"
          style={{ marginTop: "50px" }}
        >
          <div className="border-box clearfix">
            <div
              className="blackspan65 weight700 floatright"
              style={{ marginRight: "3%" }}
            >
              {/* <button
                style={{ background: "rgb(105, 118, 148)", color: "#ffffff" }}
                id="addleadbtn"
                className="btn btn_small btncard move"
                onClick={this.handleAddClick}
              >
                Add {this.props.label}
              </button> */}
              <button
                className="btn btn_small btncard move"
                style={{
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "#5cb85c",
                  borderColor: "#4cae4c",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
        {/* Below button */}
        {/* <Package /> */}
        <div
          className="widthMainComp border-box clearfix leftalign"
          style={{ top: "125px" }}
        >
          <div className="border-box blackspan65 weight700">
            <table className="middleUpperTable stdtable">
              <thead>
                <tr>
                  <th className="middleUpperTH width1TH">Name</th>
                  <th className="middleUpperTH width2TH">Qty</th>
                  <th className="middleUpperTH width3TH">Material Cost</th>
                  <th className="middleUpperTH width2TH">Labour</th>
                  <th className="middleUpperTH width2TH">Brand</th>
                  <th className="middleUpperTH width6TH">Work Done</th>
                  {/* <th className="middleUpperTH"></th> */}
                  <th className="middleUpperTH width7TH">Actions</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MiddleUpper;
